import React from 'react';
import './Spinner.css';

/**
 * Standard loading indicator. Sized via prop:
 *   <Spinner size="sm" />   16px
 *   <Spinner size="md" />   24px (default)
 *   <Spinner size="lg" />   40px
 *   <Spinner label="Loading products" />  full block w/ label
 */
export default function Spinner({ size = 'md', label, inline = false }) {
  const cls = `spinner spinner--${size}` + (inline ? ' spinner--inline' : '');
  if (label) {
    return (
      <div className="spinner-block" role="status" aria-live="polite">
        <span className={cls} aria-hidden="true" />
        <span className="spinner__label">{label}</span>
      </div>
    );
  }
  return <span className={cls} role="status" aria-label="Loading" />;
}
